var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2129_653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3179 8.25867C14.6247 8.25867 13.9728 8.52802 13.4812 9.01735C11.9045 10.846 12.0085 10.7259 11.9981 10.7363C11.5004 11.2347 10.6497 10.8824 10.6497 10.1773C10.6497 8.62856 10.646 8.74143 10.6584 8.69446L12.4003 2.18088C12.5342 1.67993 12.2368 1.16286 11.7368 1.02867C11.2348 0.894163 10.7217 1.19286 10.5878 1.6938C10.5872 1.69703 10.6253 1.56246 8.76337 8.07159C8.68144 8.35767 8.25727 8.29835 8.25727 8.00062V0.94158C8.25727 0.422893 7.83632 0.000976562 7.31892 0.000976562C6.80152 0.000976562 6.38057 0.422893 6.38057 0.94158V7.79418C6.38057 8.09501 5.95046 8.15049 5.8735 7.86063L4.30583 1.99863C4.24067 1.75574 4.08519 1.55252 3.86778 1.42704C3.14859 1.01183 2.27721 1.67693 2.49333 2.48571L4.101 8.4977C4.17893 8.78846 3.7773 8.95277 3.62812 8.69317L1.50337 5.00559C1.35367 4.74606 1.08371 4.60174 0.804693 4.60174C0.191462 4.60174 -0.202424 5.27374 0.108595 5.81362L1.60079 8.40286C2.20592 9.45346 2.52591 10.6499 2.52591 11.8631C2.52591 14.1443 4.37808 16.0003 6.65443 16.0003H7.59665C8.80466 16.0003 9.94074 15.529 10.7955 14.6736L15.7827 9.44317C15.8737 9.37127 15.989 9.17638 15.9989 8.97803C16.0188 8.58608 15.709 8.25867 15.3179 8.25867ZM10.1488 10.9221C8.3021 11.1682 6.90958 12.7607 6.90958 14.6268C6.90958 14.7694 6.7941 14.8848 6.65153 14.8848C6.50928 14.8848 6.39348 14.7694 6.39348 14.6268C6.39348 12.503 7.97857 10.6905 10.0804 10.4105C10.222 10.3918 10.3517 10.4912 10.3704 10.6324C10.3891 10.7737 10.2898 10.9034 10.1488 10.9221Z",
    fill: "#B91C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2129_653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandIcon);
export default __webpack_public_path__ + "static/media/stand-icon.f684984122db7fe71737fa7a309b166f.svg";
export { ForwardRef as ReactComponent };